import Vue from "vue"
import App from "./core/components/App.vue"
import NavLink from "./core/components/NavLink.vue"
import ContentLayer from "./core/components/ContentLayer.vue"
import router from "./core/router"
import Ripple from 'vue-ripple-directive'
import 'material-design-icons'

Ripple.color = 'rgba(255, 255, 255, 0.2)'

Vue.directive('ripple', Ripple);
Vue.component('NavLink', NavLink);
Vue.component('ContentLayer', ContentLayer);
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
  created() {

    // hashchange for ie
    if ('-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style) { // detect it's IE11
        window.addEventListener("hashchange", (event) => {
            var currentPath = window.location.hash.slice(1);
            if (this.$route.path !== currentPath) {
                this.$router.push(currentPath)
            }
        }, false)
    }

  }

}).$mount("#app")
